import "./App.scss";
import { ThemeProvider } from "@mui/material/styles";
import { ToastContainer } from "react-toastify";
import { Route, Routes } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Theme from "./utils/Theme";
import CommonLayout from "./layouts/CommonLayout";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TopNavigationBar from "./components/TopNavigationBar";
import ReceiveOtp from "./pages/ReceiveOtp";
import ScrollToTop from "./components/Controls/ScrollToTop";

const App = () => {
  return (
    <ThemeProvider theme={Theme}>
      <TopNavigationBar />
      <ScrollToTop />
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Registration />} />
        <Route path='/verify-otp' element={<ReceiveOtp />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='*' element={<CommonLayout />} />
      </Routes>
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;
